/**
 * Lo que se le paga al proveedor por una factura: total − anticipo de la OC aplicado en la factura − notas de crédito
 * aplicadas. Es la base del saldo, de la deuda y del descuento por pronto pago (igual que en el backend). Una nota de
 * crédito no se paga: 0.
 */
export const montoAPagar = (f: {
  montoTotal: string | number; anticipoAplicado?: string | number | null; notasCreditoAplicadas?: string | number | null; tipo?: string | null;
}) => f.tipo === 'nota_credito'
  ? 0
  : Math.round((Number(f.montoTotal || 0) - Number(f.anticipoAplicado || 0) - Number(f.notasCreditoAplicadas || 0)) * 100) / 100;

/** Resumen de anticipos de una OC (GET /compras/:id → anticipos). */
export interface AnticiposOC {
  totalOC: number;
  anticiposFacturados: number;
  anticiposAplicados: number;
  saldoAnticipo: number;
  topeAnticipo: number;
}
